import React from 'react';

const Heading = (props) => {
    const { title = '' } = props;
    return (
        <h2 className="b2c__loginwrap--loginheading">{title}</h2>
    )
}

export default Heading;